import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ErrorRedirectionService } from './error-redirection.service';
import { environment } from '@env/environment.prod';
import { tap } from 'rxjs/operators';
import { DigitalDataService } from '../data-services/digital-data.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptionService implements HttpInterceptor {
  constructor(
    private errorRedirectionService: ErrorRedirectionService,
    private digitalDataService: DigitalDataService
  ) {
    // do nothing
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(tap(
      () => {
        //do nothing
      },
      (err) => {
        if (err instanceof HttpErrorResponse) {
          this.digitalDataService.setErrorDetails(err.status, err.error);
          let status;
          if (err.status == 0 || err.status == 400 || err.status == 404) {
            status = '500';
          } else {
            status = err.status;
          }
          if (environment.production) {
            if (req.url.includes('personal-policy-api') && err.status === 500) {
              this.errorRedirectionService.redirect(status);
            } else {
              return true;
            }
          } else {
            console.error('errr - not in prod so no redirection', err.status);
          }
        }
      }
    ));
  }
}
